import { Modal } from "flowbite-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import UpgradeModal from "./UpgradeModal";
function PopupModals({ showModal, setshowModal, popupMessage }) {
  const navigate = useNavigate();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  return (
    <div>
      <Modal dismissible show={showModal?.first} size="xl">
        <div class="relative   w-full  ">
          <div class="relative bg-cloud rounded-[8px] shadow-modal">
            <div class="flex items-center justify-end p-4">
              <button
                type="button"
                class="z-50 flex justify-center items-center transition duration-700 ease-in-out hover:scale-125 text-black hover:text-gray-700"
                data-modal-hide="default-modalOne"
                onClick={() => {
                  setshowModal({ ...showModal, first: false });
                }}
              >
                <svg
                  className="w-9 h-9"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
            </div>

            <div class="flex justify-end">
              <img
                src={window.location.origin + "/images/rocket.svg"}
                className="w-full max-w-[180px] absolute mt-[-80px] mr-[-60px]"
                alt="upgrade"
              />
            </div>

            <div className="p-4 text-start pt-[136px]">
              <p className="text-[40px] font-[400] pb-4">
                Please <strong>Upgrade</strong> <br /> To{" "}
                {popupMessage ? popupMessage : "Use YouTube Chat"}
              </p>

              <p className="text-[26px] font-[400]">
                Fore more Features and better experience please upgrade One
              </p>
            </div>

            <div className="px-12 py-4 pb-6">
              <button
                type="button"
                data-modal-hide="default-modalOne"
                className="flex items-center justify-center py-2 px-10 rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7] w-full"
                onClick={() => {
                  // navigate("/subscription");
                  setshowModal({ ...showModal, first: false });
                  setShowUpgradeModal(true);
                }}
              >
                <svg className="icon me-4 text-[20px]">
                  <use href="#icon_taaj"></use>
                </svg>
                <span>UPGRADE NOW</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal dismissible show={showModal?.second} size="xl">
        <div class="relative w-full ">
          <div class="relative bg-white rounded-[8px] shadow-modal">
            <div class="flex items-center justify-end p-4">
              <button
                type="button"
                class="z-50 flex justify-center items-center transition duration-700 ease-in-out hover:scale-125 text-black hover:text-gray-700"
                data-modal-hide="default-modal"
                onClick={() => {
                  setshowModal({ ...showModal, second: false });
                }}
              >
                <svg
                  className="w-9 h-9"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
            </div>

            <div class="flex justify-center py-4">
              <img
                src="/images/upgrate.png"
                className="w-full max-w-[280px]"
                alt="upgrade"
              />
            </div>

            <div className="px-4 text-center">
              <p className="text-[36px] font-[400] pb-2">
                Please <strong>Upgrade</strong> <br /> To {popupMessage || ""}
              </p>

              <p className="text-[24px] font-[400]">
                Fore more Features and better experience please upgrade
              </p>
            </div>

            <div className="px-12 py-2 pb-6">
              <button
                type="button"
                data-modal-hide="default-modal"
                className="flex items-center justify-center py-2 px-10 rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7] w-full"
                onClick={() => {
                  // navigate("/subscription");
                  setshowModal({ ...showModal, second: false });
                  setShowUpgradeModal(true);
                }}
              >
                <svg className="icon me-4 text-[20px]">
                  <use href="#icon_taaj"></use>
                </svg>
                <span>UPGRADE NOW</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal dismissible show={showModal?.third} size="xl">
        <div class="relative  w-full ">
          <div class="relative bg-gradient rounded-[8px] shadow-modal">
            <div class="flex items-center justify-end p-4">
              <button
                type="button"
                class="z-50 flex justify-center items-center transition duration-700 ease-in-out hover:scale-125 text-black hover:text-gray-700"
                data-modal-hide="default-modalTwo"
                onClick={() => {
                  setshowModal({ ...showModal, third: false });
                }}
              >
                <svg
                  className="w-9 h-9"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
            </div>

            <div class="flex justify-center pt-2 mb-[-10px]">
              <img
                src="/images/second-rocket.svg"
                className="w-full"
                alt="upgrade"
              />
            </div>

            <div className="bg-white rounded-b-[8px]">
              <div className="px-4 text-center">
                <p className="text-[36px] font-[400] pb-2">
                  Please <strong>Upgrade</strong> <br /> To {popupMessage}
                </p>

                <p className="text-[24px] font-[400]">
                  Fore more Features and better experience please upgrade
                </p>
              </div>

              <div className="px-12 py-2 pb-6">
                <button
                  type="button"
                  data-modal-hide="default-modalTwo"
                  className="flex items-center justify-center py-2 px-10 rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white  hover:from-[#9D3784] hover:to-[#1A71A7] w-full"
                  onClick={() => {
                    // navigate("/subscription");
                    setshowModal({ ...showModal, third: false });
                    setShowUpgradeModal(true);
                  }}
                >
                  <svg className="icon me-4 text-[20px]">
                    <use href="#icon_taaj"></use>
                  </svg>
                  <span>UPGRADE NOW</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <UpgradeModal isOpen={showUpgradeModal} setIsOpen={setShowUpgradeModal} />
    </div>
  );
}

export default PopupModals;
